import './OpButton.scss'

import cx from 'bem-classnames'

import React from 'react'

const NOOP = () => {}

const OpButton = ({onClick, bsStyle, children, className, disabled, pending, large, xlarge, dataTestId}) => {

  const classes = {
    name: 'opbtn',
    modifiers: ['disabled', 'bsStyle', 'pending', 'large', 'xlarge']
  }

  let btnCls = cx(classes, {
      bsStyle,
      disabled,
      pending,
      large,
      xlarge
  })
  if (className) {
    btnCls += ` ${className}`
  }

  return (
    <button onClick={pending ? NOOP : onClick} className={btnCls} disabled={disabled} data-testid={dataTestId || className}>{
      !pending ?
      children :
      <span className="-spinner"><i className="fa fa-spinner fa-spin fa-fw"/></span>
    }</button>
  )
}

export default OpButton
